// Firebase client SDK singleton — initialised lazily on first import.
// Config comes from `frontend/.env` via CRA's process.env.REACT_APP_* pass-through.
import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onIdTokenChanged, browserLocalPersistence, setPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// The admin email is stamped into a static env var so we can gate UI as well
// as backend without an extra API call.
export const ADMIN_EMAIL = (process.env.REACT_APP_ADMIN_EMAIL || "").toLowerCase();

let _app;
export function firebaseApp() {
  if (!_app) {
    _app = getApps()[0] || initializeApp(firebaseConfig);
  }
  return _app;
}

let _auth;
export function firebaseAuth() {
  if (!_auth) {
    _auth = getAuth(firebaseApp());
    // Persist across tabs/reloads — user stays signed in until explicit sign-out.
    setPersistence(_auth, browserLocalPersistence).catch(() => {});
  }
  return _auth;
}

const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });

export async function signInWithGoogle() {
  return signInWithPopup(firebaseAuth(), provider);
}

export async function firebaseSignOut() {
  return signOut(firebaseAuth());
}

// Re-export so callers can subscribe to identity/token refresh in one line.
export { onIdTokenChanged };

// Helper: check if a given Firebase user is our admin.
export function isAdmin(user) {
  if (!user || !user.email) return false;
  return user.email.toLowerCase() === ADMIN_EMAIL;
}
